import { render, staticRenderFns } from "./OptionDisplay.vue?vue&type=template&id=0744e058&scoped=true&"
import script from "./OptionDisplay.vue?vue&type=script&lang=js&"
export * from "./OptionDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0744e058",
  null
  
)

export default component.exports